import {FormErrors} from 'redux-form';
import {EMAIL_RE, isEmpty, maxLength, matchRegexp, getErrorTexts} from 'validataion';
import {WithTranslationProps} from 'hoc/withTranslation';
import {SubscriptionFormFields} from './SubscriptionForm';

export default function validate(values: SubscriptionFormFields, {i18n}: WithTranslationProps) {
    const errorTexts = getErrorTexts(i18n);
    const errors: FormErrors<SubscriptionFormFields> = {};

    if (isEmpty(values.email)) {
        errors.email = errorTexts.REQUIRED;
    } else if (!matchRegexp(values.email, EMAIL_RE)) {
        errors.email = errorTexts.FORMAT;
    } else if (!maxLength(values.email, 255)) {
        errors.email = errorTexts.MAX_LEN;
    }

    return errors;
}
